import { LessonsForm } from "../../components/Forms/LessonsForm";

const NewLessonsPage = () => {
  return <LessonsForm />;
};

export default NewLessonsPage;
